module.exports = __webpack_public_path__ + "assets/icon-flag-outline-component.e75700f0.svg";